import React, { useRef, useState } from "react";

import image1 from "views/whats-new/img/gallery/businessgrowth.png";
import image2 from "views/whats-new/img/gallery/itreasuryhome.png";
import image3 from "views/whats-new/img/gallery/itreasury.png";
import image4 from "views/whats-new/img/gallery/lock.png";
import image5 from "views/whats-new/img/gallery/overdraft.png";
import image6 from "views/whats-new/img/gallery/chair.png";
import view from "views/whats-new/img/gallery/view.png";

export default function App() {
  return (
    <>
      <div className="py-20">
        <div className="column-count3  sm-column-count-2 lg:gap-10 md:gap-10 gap-6">
          <div className="lg:mb-12 md:mb-12 mb-8">
            <div className="relative">
              <img src={image1} className="w-full maxh-233px" />
            </div>
            <div className="caption mt-2">
              <h1 className="text-black fsize20 font-bold sm-fsize12">
                Business Growth
              </h1>
              <div className="flex items-center justify-between mt-1">
                <p className="text-black fsize17 sm-fsize10">5 days ago</p>
                <div className="flex items-center">
                  <div>
                    <img src={view} className="sm-view-wh" />
                  </div>
                  <p className="text-black fsize17 sm-fsize10 ml-2">
                    1.5k views
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:mb-0 md:mb-0 mb-8">
            <div className=" ">
              <img src={image2} className="w-full  maxh-522px" />
            </div>
            <div className="caption mt-2">
              <h1 className="text-black fsize20 font-bold sm-fsize12">
                ICICI Bank iTreasury
              </h1>
              <div className="flex items-center justify-between mt-1">
                <p className="text-black fsize17 sm-fsize10">5 days ago</p>
                {/* <div className="flex items-center">
                  <div>
                    <img src={view} />
                  </div>
                  <p className="text-black fsize17 sm-fsize10 ml-2">1.5k views</p>
                </div> */}
              </div>
            </div>
          </div>

          <div className="lg:mb-12 md:mb-12 mb-8">
            <div className="">
              <img src={image3} className="w-full  maxh-382px " />
            </div>
            <div className="caption mt-2">
              <h1 className="text-black fsize20 font-bold sm-fsize12">
                ICICI Bank iTreasury
              </h1>
              <div className="flex items-center justify-between mt-1">
                <p className="text-black fsize17 sm-fsize10">5 days ago</p>
                {/* <div className="flex items-center">
                  <div>
                    <img src={view} />
                  </div>
                  <p className="text-black fsize17 sm-fsize10 ml-2">1.5k views</p>
                </div> */}
              </div>
            </div>
          </div>

          <div className="lg:mb-0 md:mb-0 mb-8">
            <div className=" ">
              <img src={image4} className="w-full  maxh-373px" />
            </div>
            <div className="caption mt-2">
              <h1 className="text-black fsize20 font-bold sm-fsize12">
                Overdraft Protection
              </h1>
              <div className="flex items-center justify-between mt-1">
                <p className="text-black fsize17 sm-fsize10">5 days ago</p>
                {/* <div className="flex items-center">
                  <div>
                    <img src={view} />
                  </div>
                  <p className="text-black fsize17 sm-fsize10 ml-2">1.5k views</p>
                </div> */}
              </div>
            </div>
          </div>

          <div className="lg:mb-12 md:mb-12 mb-8">
            <div className=" ">
              <img src={image5} className="w-full  maxh-521px" />
            </div>
            <div className="caption mt-2">
              <h1 className="text-black fsize20 font-bold sm-fsize12">
                Overdraft Protection
              </h1>
              <div className="flex items-center justify-between mt-1">
                <p className="text-black fsize17 sm-fsize10">5 days ago</p>
                {/* <div className="flex items-center">
                  <div>
                    <img src={view} />
                  </div>
                  <p className="text-black fsize17 sm-fsize10 ml-2">1.5k views</p>
                </div> */}
              </div>
            </div>
          </div>

          <div className="lg:mb-0 md:mb-0 mb-8">
            <div className="relative">
              <img src={image6} className="w-full maxh-233px " />
            </div>
            <div className="caption mt-2">
              <h1 className="text-black fsize20 font-bold sm-fsize12">
                ICICI Bank iTreasury
              </h1>
              <div className="flex items-center justify-between mt-1">
                <p className="text-black fsize17 sm-fsize10">5 days ago</p>
                {/* <div className="flex items-center">
                  <div>
                    <img src={view} />
                  </div>
                  <p className="text-black fsize17 sm-fsize10 ml-2">1.5k views</p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* 2nd section */}
        <div className="column-count3  sm-column-count-2 lg:gap-10 md:gap-10 gap-6 lg:mt-12 md:mt-12 mt-8">
          <div className="lg:mb-12 md:mb-12 mb-8">
            <div className="relative">
              <img src={image1} className="w-full maxh-233px" />
            </div>
            <div className="caption mt-2">
              <h1 className="text-black fsize20 font-bold sm-fsize12">
                Business Growth
              </h1>
              <div className="flex items-center justify-between mt-1">
                <p className="text-black fsize17 sm-fsize10">5 days ago</p>
                <div className="flex items-center">
                  <div>
                    <img src={view} className="sm-view-wh" />
                  </div>
                  <p className="text-black fsize17 sm-fsize10 ml-2">
                    1.5k views
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:mb-0 md:mb-0 mb-8">
            <div className=" ">
              <img src={image2} className="w-full  maxh-522px" />
            </div>
            <div className="caption mt-2">
              <h1 className="text-black fsize20 font-bold sm-fsize12">
                ICICI Bank iTreasury
              </h1>
              <div className="flex items-center justify-between mt-1">
                <p className="text-black fsize17 sm-fsize10">5 days ago</p>
                {/* <div className="flex items-center">
                  <div>
                    <img src={view} />
                  </div>
                  <p className="text-black fsize17 sm-fsize10 ml-2">1.5k views</p>
                </div> */}
              </div>
            </div>
          </div>

          <div className="lg:mb-12 md:mb-12 mb-0 sm-inline-grid">
            <div className="">
              <img src={image5} className="w-full  maxh-521px " />
            </div>
            <div className="caption mt-2">
              <h1 className="text-black fsize20 font-bold sm-fsize12">
                Overdraft Protection
              </h1>
              <div className="flex items-center justify-between mt-1">
                <p className="text-black fsize17 sm-fsize10">5 days ago</p>
                {/* <div className="flex items-center">
                  <div>
                    <img src={view} />
                  </div>
                  <p className="text-black fsize17 sm-fsize10 ml-2">1.5k views</p>
                </div> */}
              </div>
            </div>
          </div>

          <div className="lg:mb-0 md:mb-0 mb-8">
            <div className=" ">
              <img src={image6} className="w-full  maxh-373px" />
            </div>
            <div className="caption mt-2">
              <h1 className="text-black fsize20 font-bold sm-fsize12">
                ICICI Bank iTreasury
              </h1>
              <div className="flex items-center justify-between mt-1">
                <p className="text-black fsize17 sm-fsize10">5 days ago</p>
                <div className="flex items-center">
                  <div>
                    <img src={view} className="sm-view-wh" />
                  </div>
                  <p className="text-black fsize17 sm-fsize10 ml-2">
                    1.5k views
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:mb-12 md:mb-12 mb-8">
            <div className=" ">
              <img src={image3} className="w-full  w-full  maxh-382px" />
            </div>
            <div className="caption mt-2">
              <h1 className="text-black fsize20 font-bold sm-fsize12">
                Overdraft Protection
              </h1>
              <div className="flex items-center justify-between mt-1">
                <p className="text-black fsize17 sm-fsize10">5 days ago</p>
                {/* <div className="flex items-center">
                  <div>
                    <img src={view} />
                  </div>
                  <p className="text-black fsize17 sm-fsize10 ml-2">1.5k views</p>
                </div> */}
              </div>
            </div>
          </div>

          <div className="lg:mb-0 md:mb-0">
            <div className="relative">
              <img src={image4} className="w-full maxh-373px " />
            </div>
            <div className="caption mt-2">
              <h1 className="text-black fsize20 font-bold sm-fsize12">
                Overdraft Protection
              </h1>
              <div className="flex items-center justify-between mt-1">
                <p className="text-black fsize17 sm-fsize10">5 days ago</p>
                {/* <div className="flex items-center">
                  <div>
                    <img src={view} />
                  </div>
                  <p className="text-black fsize17 sm-fsize10 ml-2">1.5k views</p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
